import { render, staticRenderFns } from "./feature-move-dialog.vue?vue&type=template&id=4829cf82"
import script from "./feature-move-dialog.vue?vue&type=script&lang=js"
export * from "./feature-move-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports